export const Theme = {
  colors: {
    WHITE: "#FFFFFF",
    STONE: "#F5F5F5",
    LIGHTGRAY: "#808080",
    LIGHTGRAY2: "#f9f9f9",
    DARKGRAY: "#545454",
    BLACK: "#000000",
    SKYBLUE: "#5CAFEB",
    BLUE: "#168CE3",
  },
};
